import { DEFAULT_ANNOUNCEMENT_MODAL_CONFIG } from "components/ui/AnnouncementModal/announcementModalConfig";

// Note that for each flag you intend to use here, you must
// enable this flag to be used with the client SDK
// inside of the Settings section of the given flag, otherwise
// the flag simply won't be returned to the client
export enum Flag {
  // Setting the Timers feature's minimum allowed interval
  TIMERS_MIN_INTERVAL = "ui.timers-min-interval",

  // Enable / disable the AI Assistant feature in code editors

  // enable / disable passing metadata to AI assistant

  // for orgs that still use Global.URL.queryParams.environment in app
  ENABLE_PROFILES_WITH_ENV = "superblocks.profiles.settings-enabled-with-env",

  ENABLE_VALIDATE_SUBJECT_TOKEN = "agent.plugins.auth.validate_subject_token_during_obo_flow.enabled",

  PARALLEL_POOL_MAX_SIZE = "agent.quota.api.parallel.pool.size.max",

  ENABLE_SUPERBLOCKS_SUPPORT_UPDATES = "server.rbac.superblocks-support-updates-enabled",
  ENABLE_PADDING_ADVANCED_MODE = "ui.padding.enable-advanced-mode",
  ENABLE_TABLE_IMAGE_SIZE = "ui.enable-table-image-size",

  ENABLE_RESOURCE_SIGNING = "ui.enable-resource-signing",

  // Show experimental integration fields
  INTEGRATION_ENABLE_EXPERIMENTAL = "ui.integration.enable-experimental",

  // Enable scoped catalog/schemas for Databricks integrations
  INTEGRATIONS_DATABRICKS_SCOPED = "integrations.databricks.scoped",

  // Kill switch for the Zendesk OAuth rollout: off, the integration form offers only the API
  // token method. Same key as ZENDESK_OAUTH_ROLLOUT_FLAG in the shared Zendesk template.
  INTEGRATIONS_ZENDESK_OAUTH = "integrations.zendesk.oauth",

  ENABLE_APP_CLONE = "ui.enable-app-clone",

  ENABLE_EMBED = "ui.enable-embed",
  ACCESS_TOKEN_MAX_EXPIRATION_SECONDS = "server.org.token.max.expiration.seconds",

  ENABLE_MULTIPAGE = "ui.multi-page.enabled",
  ENABLE_ORG_MIGRATE_TO_EU_BANNER = "ui.banner.org-migrated-to-eu.enabled",

  SALES_SETTINGS_JSON = "superblocks.sales_settings.json",
  SALES_BILLING_EMAIL = "superblocks.sales_billing_email",
  CODE_FORMATTING = "ui.code-editor.enable-code-formatting",

  ENABLE_TEMPLATE = "ui.enable-template",
  ENABLE_KEY_VALUE_WIDGET = "ui.widgets.keyvalue.enabled",
  DISABLE_LOAD_METADATA_FOR_INTEGRATIONS = "ui.disable-load-metadata-for-integrations",

  ENABLE_INTERCOM_LIVE_CHAT = "ui.intercom-live-chat.enabled",

  ENABLE_RBAC_V2 = "superblocks.rbac.v2.server.enforce-authz",
  RBAC_APPLICATION_PRINCIPAL_ENABLED = "superblocks.rbac.application-principal.enabled",

  ENABLE_CUSTOM_PAGE_LOAD_ACTIONS = "ui.custom-page-load-actions.enabled",

  UI_BLOCKS_FOR_USERS = "ui.ui-blocks.enabled", // Used by Superblocks users (end-users & creators)
  UI_BLOCKS_ADMINISTRATION = "ui-blocks.administration",
  ENABLE_REFERENCE_ANALYSIS = "ui.reference-analysis.enabled",
  UI_ADD_COMPONENT_FLOW = "ui.add-component-flow.enabled",

  ENABLE_AI_COMPONENT_EDITING = "ui.ai-component-editing.enabled",
  ENABLE_AI_COMPONENT_EDITING_AUDIO_TRANSCRIPTION = "ui.ai-component-editing-audio-transcription.enabled",
  SHOW_AI_DISCARD_FEEDBACK = "ui.ai-component-editing.show-discard-feedback",

  // TODO(pbardea): This blog of flags are temporary flags and should be phased
  // out by end of 2024.
  UI_SHOW_CONTEXT_MODES = "ui.ai.code-completion.show_context_modes",
  UI_AI_IN_BETA = "ui.ai.code-completion.is_beta",

  ENABLE_PROGRAMMATIC_TABLE = "ui.programmatic-table.enabled",

  ENABLE_EMAIL_PLUGIN = "org.email.plugin.enabled",

  ENABLE_DEEP_BINDINGS_PATHS = "ui.use-deep-bindings-paths.enabled",

  ENABLE_OAUTH_TOKEN_EXCHANGE = "ui.oauth-token-exchange.enabled",

  EVALUATOR_CACHE_DERIVED_PROPERTIES = "ui.evaluator.cache-derived-properties",
  HIDE_SUPERBLOCKS_HEADER = "ui.hide-superblocks-header",

  AI_MULTI_COMPONENT_EDITING = "ui.ai-multi-component-editing.enabled",

  AI_GCN_DEMO_INTEGRATION_IDS = "ai.gcn-demo-integration-ids",

  AI_ACTION_PROCESSING_DELAY = "ai.clark-action-processing-delay",

  ENABLE_OPTIMIZED_PAGE_LOAD = "ui.optimized-page-load.enabled",

  ALLOW_DEV_ENV = "superblocks.dev-env.enabled",

  SHOW_CODE_MODE_APP_BTN = "ui.code-mode-app-btn.enabled",

  DISABLE_LEGACY_APPS = "ui.disable-legacy-apps",

  CLOUDPREM_INTERCOM = "cloudprem.intercom",

  // Enable workflows for V2 orgs (for fetch credentials feature)
  V2_ORG_ENABLE_WORKFLOWS = "org.v2.enable-workflows-for-fetch-credentials",

  AI_FACTS_ENABLED = "ai.facts.enabled",
  AI_DASHBOARD_FILE_UPLOAD_ENABLED = "ai.dashboard-file-upload.enabled",
  AI_DASHBOARD_CHAT_LLMOBS_ENABLED = "ai.dashboard-chat.llmobs.enabled",
  AI_FILE_UPLOAD_ENABLED = "ai.file-upload.enabled",
  AI_SUGGEST_WHATS_NEXT = "ai.suggest-whats-next",
  BUILDER_PREFERENCES_ENABLED = "ui.builder-preferences.enabled",
  CLARK_ATTACHMENT_DOWNLOAD_ENABLED = "ai.clark-attachment-download.enabled",
  CLARK_SPREADSHEET_ATTACHMENTS_ENABLED = "ui.clark-ai.spreadsheet-attachments-enabled",

  AI_APP_KNOWLEDGE_CHAT_ENABLED = "ai.app-knowledge.enabled.chat",

  // Enable Superblocks 2.0 view toggle for V1 orgs
  V1_ORG_ENABLE_SUPERBLOCKS_2_VIEW = "org.v1.enable-superblocks-2-view",

  // Set the default Superblocks 2.0 view for V1 orgs (works with or without toggle)
  V1_ORG_DEFAULT_SUPERBLOCKS_2_VIEW = "org.v1.default-superblocks-2-view",

  // Enable the Data Tags (Environments) view to replace Profiles
  ENABLE_DATA_TAGS_VIEW = "settings.enable-data-tags-view",
  DEFAULT_DATA_TAGS_ENABLED = "superblocks.data-tags.enable-default",
  REMOVE_DEFAULT_INTEGRATION_CONFIGURATION = "superblocks.integrations.remove-default",

  // Show file upload UI on the Clark AI homepage (requires CLARK_AI_HOMEPAGE as well)
  HOMEPAGE_FILE_UPLOAD = "homepage.file-upload",

  // Integration tagging on the Clark AI homepage prompt (requires CLARK_AI_HOMEPAGE as well)
  HOMEPAGE_TAGGING = "homepage.tagging",

  // Show the third-party import (Replit/Lovable/v0/zip) entry points on the Clark AI homepage
  THIRD_PARTY_IMPORT_ENABLED = "ui.third-party-import.enabled",

  // Homepage create menu + Clark template; see homepage-app-mode.ts (only-2, both-2-and-3, default-3, only-3)
  HOMEPAGE_APP_MODE = "ui.homepage-app.mode",

  ENABLE_SUGGEST_INTEGRATIONS_BANNER = "ui.suggest-integrations.banner",

  SDK_API_ENABLED = "clark.sdk-api.enabled",
  SDK_API_SCOPED_TOKENS_ENABLED = "ui.sdk-api.scoped-tokens.enabled",
  ORCHESTRATOR_EXECUTE_RESPONSE_SIZE_LIMIT_BYTES = "orchestrator.execute.response-size-limit.bytes",
  AI_BYO_INFERENCE_ENABLED = "superblocks.ai.byo-inference.enabled",

  // Billing usage page
  BILLING_USAGE_PAGE_ENABLED = "billing.usage-page.enabled",
  BILLING_USAGE_LIMITS_ENABLED = "billing.usage-limits.enabled",

  // Billing /spending page (one-time refill history + auto-refill config).
  // Off by default. Independent of BILLING_REFILL/BILLING_AUTO_TOPUP — gating
  // the page hides the route + nav item but the underlying refill/auto
  // endpoints stay reachable from other surfaces (Manage Plan modal).
  BILLING_SPENDING_PAGE_ENABLED = "superblocks.billing.spending-page.enabled",

  // Manual one-time credit refill (Stripe charge via /v1/billing/auto-topup/manual-charge).
  // Off by default. When off, the "Refill credits" trigger button on Manage
  // Plan modal + the /spending page is hidden, the in-Manage-Plan TopUpView
  // is unreachable, and the server-side endpoint returns "feature_disabled".
  BILLING_REFILL_ENABLED = "superblocks.billing.refill.enabled",

  // When on, the Plan Summary surfaces a "Switch to annual" CTA for
  // monthly Teams orgs, and renders a pending pill when a switch has been
  // scheduled. Off → both surfaces hide. Server endpoint stays open under
  // RBAC + plan + active-sub preconditions.
  ENABLE_BILLING_INTERVAL_SWITCH = "superblocks.billing.interval-switch.enabled",

  // POC-only kill-switch for the "Add credit card" entry point on the plan
  // banner. Off by default — POC orgs need an explicit LD targeting rule
  // before the button appears, so we can roll the POC refill flow out
  // gradually without affecting TEAMS (which goes through Stripe Checkout
  // at signup, no add-card button needed). Independent of
  // BILLING_REFILL_ENABLED / BILLING_AUTO_TOPUP — those gate the *use* of
  // refills; this gates the *onboarding* entry point.
  BILLING_POC_CREDIT_CARD_ENABLED = "superblocks.billing.poc-credit-card.enabled",

  // Spend Alerts section on /spending. When on, renders a new
  // SpendAlertsSection below SpendLimitsSection where admins can configure
  // proactive email alerts on org/per-user/overage/refill spend. Off by
  // default — the parent /spending page also has to be on
  // (BILLING_SPENDING_PAGE_ENABLED), so this flag only matters once that one
  // is enabled.
  BILLING_SPEND_ALERTS_ENABLED = "superblocks.billing.spend-alerts.enabled",

  // Route execute requests through the data plane gateway endpoint
  ENABLE_DATA_PLANE_GATEWAY = "ui.data-plane-gateway.enabled",

  // Credit card gate: block trial orgs until they enter a credit card
  ENABLE_CREDIT_CARD_GATE = "superblocks.billing.credit-card-gate.enabled",

  AUDIT_V2_ENABLED = "superblocks.audit.v2.enabled",

  ANNOUNCEMENT_MODAL_CONFIG = "ui.announcement-modal.config",
  ANNOUNCEMENT_MODAL_ENABLED = "ui.announcement-modal.enabled",

  ENABLE_INTRODUCING_CLARK_MODAL = "ui.introducing-clark-modal.enabled",

  // Enable grid view on the /apps page (thumbnail cards instead of list)
  HOMEPAGE_GRID_VIEW = "homepage.grid-view",

  // Join org gate: show new users a gate to request joining an existing org with matching domain
  ENABLE_JOIN_ORG_GATE = "superblocks.onboarding.join-org-gate.enabled",

  // App AI default integration: admin settings page + Clark uses the default when building AI-powered apps
  APP_AI_DEFAULT_INTEGRATION_ENABLED = "superblocks.app-ai.default-integration.enabled",

  // Per-org NPM Registry feature (APPS-4228). Gates the Package Registry
  // admin nav entry, route, and page. Server-side POST/PUT/DELETE on
  // /api/v1/organizations/:id/npm-registry are gated by the same key.
  // Per-org rollout; pilot LinkedIn first, then graduate by removing.
  NPM_REGISTRY_ENABLED = "superblocks.npm-registry.enabled",

  // Notification inbox feature flag
  NOTIFICATIONS_INBOX_ENABLED = "superblocks.notifications-inbox.enabled",

  // App AI demo: advanced per-feature integration/model configuration.
  APP_AI_DEMO_ENABLED = "superblocks.app-ai.demo.enabled",

  // Managed Native DB rollout. Gates Clark DB tools and dashboard DB surfaces.
  MANAGED_NATIVE_DB_ENABLED = "managed-native-db.enabled",

  // Admin-only pg_dump prefix validation on lifecycle-managed integrations.
  MANAGED_NATIVE_DB_DATA_IMPORT_DUMP_ENABLED = "managed-native-db.data-import-dump.enabled",

  // Read-only App Database data view. Gates the Data tab and multipart import
  // upload. Same flag the server checks on /v1/database-lifecycle/imports.
  MANAGED_NATIVE_DB_READ_ONLY_VIEW_ENABLED = "managed-native-db.read-only-view.enabled",

  // Native DB pool provisioning wizard. Off by default because the entry point
  // is currently backed by an in-memory mock (the provisioning service does not
  // exist yet); enable it per-environment to preview the flow.
  MANAGED_NATIVE_DB_PROVISIONING_ENABLED = "managed-native-db.provisioning.enabled",

  // App Databases Usage SKUs: product flag plus UI-only billing flag (AND).
  // Server ledger/history charges are unaffected by the billing flag.
  MANAGED_NATIVE_DB_BILLING_ENABLED = "managed-native-db.billing.enabled",

  // Nav redesign — master flag for the persona-based sidebar + admin shell.
  // When off, the production nav is byte-identical to today.
  // When on, the new sidebar renders: Home/Apps/Integrations + Admin top-level,
  // admin sub-nav grouped by section.
  // Existing pages (Users, Groups, Audit Logs, etc.) are reused; their labels
  // get renamed (Knowledge→Skills, On-Premise Agents→Data Planes, etc.).
  NAV_REDESIGN_ENABLED = "nav.redesign.enabled",
  // Demo/mock admin pages that ship as part of the nav redesign but are not yet
  // backed by real data (Overview, Platform Setup, Identity, File Storage,
  // App Analytics, Observability Monitor, Platform MCP, and the
  // External Auth/Users/Experience pages). Nested under NAV_REDESIGN_ENABLED:
  // these pages only render when BOTH this flag and the redesign flag are on,
  // so the redesigned nav + real pages can ship without exposing the mocks.
  ADMIN_DEMO_PAGES_ENABLED = "admin.demo.pages.enabled",
  // Fake Policy Agents demo: the mock Policy Agents pages and the demo
  // commit-policy run shown in the editor. Split out of
  // ADMIN_DEMO_PAGES_ENABLED so demos can show the real Policy Agents page
  // while the other mock admin pages stay on.
  ADMIN_DEMO_POLICY_AGENTS_ENABLED = "admin.demo.policy-agents.enabled",
  // Fake database provisioning demo: the Database Standardization page and
  // the editor's pretend database/file-storage provisioning card.
  BYO_DB_DEMO = "superblocks.byo-db.demo",
  // Real (non-demo) Security Center → Dependency Scans page: org-wide npm CVEs
  // backed by the /code-security/dependency-scan endpoints.
  CODE_SECURITY_DEPENDENCY_SCAN_ENABLED = "code-security.dependency-scan.enabled",
  // Security Center → Applications tab: org-wide app list with a per-app SBOM
  // view, backed by the /applications/package-usage endpoint.
  CODE_SECURITY_SBOM_ENABLED = "superblocks.code-security.sbom.enabled",
  // Policy Gates: organization-settings page for the Built-in Security Scan
  // and admin-configured Security Agents that review every deploy.
  POLICY_GATES_MVP_ENABLED = "superblocks.policy-gates.mvp.enabled",
  POLICY_GATES_SECURITY_SCANS_ENABLED = "superblocks.policy-gates.security-scans.enabled",
  POLICY_GATES_DEPENDENCY_SCAN_ENABLED = "superblocks.policy-gates.dependency-scan.enabled",

  // Allow resetting v3 apps to v2 commits by enabling template-switch reset override.
  UI_V2_REVERT_OVERRIDE_ENABLED = "ui.v2-revert-override.enabled",

  // Secrets Management page: allow Apps 2.0/3.0 (V2) orgs to see the page so
  // they can manage integration-level secrets via AWS Secrets Manager. V1 orgs
  // already see the page via OrgFeature.LegacySecretsManagement; this flag is
  // additive and only opens the gate for V2 orgs (APPS-3877).
  SECRETS_MANAGEMENT_V2_ENABLED = "superblocks.secrets-management.v2.enabled",
}

type FlagType = boolean | number | string | Record<string, any> | undefined;

export type AllFlags = {
  [K in Flag]: FlagType;
};
export type Flags = Partial<AllFlags>;

export const defaults = {
  [Flag.TIMERS_MIN_INTERVAL]: 5000,
  [Flag.ENABLE_PROFILES_WITH_ENV]: false,
  [Flag.PARALLEL_POOL_MAX_SIZE]: 50,
  [Flag.ENABLE_SUPERBLOCKS_SUPPORT_UPDATES]: false,
  [Flag.ENABLE_PADDING_ADVANCED_MODE]: false,
  [Flag.ENABLE_TABLE_IMAGE_SIZE]: false,
  [Flag.ENABLE_RESOURCE_SIGNING]: false,
  [Flag.INTEGRATION_ENABLE_EXPERIMENTAL]: false,
  [Flag.INTEGRATIONS_DATABRICKS_SCOPED]: false,
  [Flag.INTEGRATIONS_ZENDESK_OAUTH]: false,
  [Flag.ENABLE_APP_CLONE]: true, // this will only be disabled for customers using application signing
  [Flag.ENABLE_EMBED]: false,
  [Flag.ACCESS_TOKEN_MAX_EXPIRATION_SECONDS]: 31536000, // 1 year
  [Flag.ENABLE_MULTIPAGE]: false,
  [Flag.ENABLE_ORG_MIGRATE_TO_EU_BANNER]: false,
  [Flag.SALES_SETTINGS_JSON]: {
    app_block_reason: null,
    block_config: {
      title: null,
      message: null,
      closable: null,
    },
  },
  [Flag.SALES_BILLING_EMAIL]: "billing-requests@superblockshq.com",
  [Flag.CODE_FORMATTING]: false,
  [Flag.ENABLE_TEMPLATE]: false,
  [Flag.ENABLE_KEY_VALUE_WIDGET]: false,
  [Flag.DISABLE_LOAD_METADATA_FOR_INTEGRATIONS]: [],
  [Flag.ENABLE_INTERCOM_LIVE_CHAT]: false,
  [Flag.ENABLE_RBAC_V2]: false,
  [Flag.RBAC_APPLICATION_PRINCIPAL_ENABLED]: false,
  [Flag.ENABLE_CUSTOM_PAGE_LOAD_ACTIONS]: false,
  [Flag.UI_BLOCKS_FOR_USERS]: false,
  [Flag.UI_BLOCKS_ADMINISTRATION]: false,
  [Flag.ENABLE_REFERENCE_ANALYSIS]: false,
  [Flag.UI_ADD_COMPONENT_FLOW]: false,
  [Flag.ENABLE_AI_COMPONENT_EDITING]: false,
  [Flag.ENABLE_AI_COMPONENT_EDITING_AUDIO_TRANSCRIPTION]: false,
  [Flag.SHOW_AI_DISCARD_FEEDBACK]: false,
  [Flag.ENABLE_PROGRAMMATIC_TABLE]: false,
  [Flag.ENABLE_EMAIL_PLUGIN]: false,
  [Flag.ENABLE_DEEP_BINDINGS_PATHS]: false,
  [Flag.UI_AI_IN_BETA]: false,
  [Flag.UI_SHOW_CONTEXT_MODES]: false,
  [Flag.ENABLE_OAUTH_TOKEN_EXCHANGE]: false,
  [Flag.EVALUATOR_CACHE_DERIVED_PROPERTIES]: false,
  [Flag.HIDE_SUPERBLOCKS_HEADER]: false,
  [Flag.AI_MULTI_COMPONENT_EDITING]: false,
  [Flag.ENABLE_OPTIMIZED_PAGE_LOAD]: false,
  [Flag.AI_GCN_DEMO_INTEGRATION_IDS]: {},
  [Flag.AI_ACTION_PROCESSING_DELAY]: 500,
  [Flag.ALLOW_DEV_ENV]: false,
  [Flag.SHOW_CODE_MODE_APP_BTN]: false,
  [Flag.DISABLE_LEGACY_APPS]: false,
  [Flag.ENABLE_VALIDATE_SUBJECT_TOKEN]: true,
  [Flag.CLOUDPREM_INTERCOM]: true,
  [Flag.AI_FACTS_ENABLED]: false,
  [Flag.AI_DASHBOARD_FILE_UPLOAD_ENABLED]: false,
  [Flag.AI_DASHBOARD_CHAT_LLMOBS_ENABLED]: true,
  [Flag.AI_FILE_UPLOAD_ENABLED]: false,
  [Flag.AI_SUGGEST_WHATS_NEXT]: false,
  [Flag.BUILDER_PREFERENCES_ENABLED]: false,
  [Flag.CLARK_ATTACHMENT_DOWNLOAD_ENABLED]: false,
  [Flag.CLARK_SPREADSHEET_ATTACHMENTS_ENABLED]: false,
  [Flag.AI_APP_KNOWLEDGE_CHAT_ENABLED]: false,
  [Flag.V2_ORG_ENABLE_WORKFLOWS]: false,
  [Flag.V1_ORG_ENABLE_SUPERBLOCKS_2_VIEW]: false,
  [Flag.V1_ORG_DEFAULT_SUPERBLOCKS_2_VIEW]: false,
  [Flag.ENABLE_DATA_TAGS_VIEW]: false,
  [Flag.REMOVE_DEFAULT_INTEGRATION_CONFIGURATION]: false,
  [Flag.HOMEPAGE_FILE_UPLOAD]: false,
  [Flag.HOMEPAGE_TAGGING]: false,
  [Flag.THIRD_PARTY_IMPORT_ENABLED]: false,
  [Flag.HOMEPAGE_APP_MODE]: "",
  [Flag.ENABLE_SUGGEST_INTEGRATIONS_BANNER]: false,
  [Flag.SDK_API_ENABLED]: false,
  [Flag.SDK_API_SCOPED_TOKENS_ENABLED]: false,
  [Flag.ORCHESTRATOR_EXECUTE_RESPONSE_SIZE_LIMIT_BYTES]: undefined,
  [Flag.AI_BYO_INFERENCE_ENABLED]: false,
  [Flag.BILLING_USAGE_PAGE_ENABLED]: false,
  [Flag.BILLING_USAGE_LIMITS_ENABLED]: true,
  [Flag.BILLING_SPENDING_PAGE_ENABLED]: false,
  [Flag.BILLING_REFILL_ENABLED]: false,
  [Flag.ENABLE_BILLING_INTERVAL_SWITCH]: false,
  [Flag.BILLING_POC_CREDIT_CARD_ENABLED]: false,
  [Flag.BILLING_SPEND_ALERTS_ENABLED]: false,
  [Flag.ENABLE_DATA_PLANE_GATEWAY]: false,
  [Flag.ENABLE_CREDIT_CARD_GATE]: false,
  [Flag.AUDIT_V2_ENABLED]: false,
  [Flag.ANNOUNCEMENT_MODAL_CONFIG]: DEFAULT_ANNOUNCEMENT_MODAL_CONFIG,
  [Flag.ANNOUNCEMENT_MODAL_ENABLED]: false,
  [Flag.ENABLE_INTRODUCING_CLARK_MODAL]: false,
  [Flag.HOMEPAGE_GRID_VIEW]: false,
  [Flag.ENABLE_JOIN_ORG_GATE]: false,
  [Flag.APP_AI_DEFAULT_INTEGRATION_ENABLED]: false,
  [Flag.NPM_REGISTRY_ENABLED]: false,
  // Off until LaunchDarkly explicitly enables it, so the Inbox nav is gated
  // per-environment. (`superblocks.notifications-inbox.enabled`.)
  [Flag.NOTIFICATIONS_INBOX_ENABLED]: false,
  [Flag.APP_AI_DEMO_ENABLED]: false,
  [Flag.MANAGED_NATIVE_DB_ENABLED]: false,
  [Flag.MANAGED_NATIVE_DB_DATA_IMPORT_DUMP_ENABLED]: false,
  [Flag.MANAGED_NATIVE_DB_READ_ONLY_VIEW_ENABLED]: false,
  [Flag.MANAGED_NATIVE_DB_PROVISIONING_ENABLED]: false,
  [Flag.MANAGED_NATIVE_DB_BILLING_ENABLED]: false,
  [Flag.DEFAULT_DATA_TAGS_ENABLED]: false,
  [Flag.NAV_REDESIGN_ENABLED]: false,
  [Flag.ADMIN_DEMO_PAGES_ENABLED]: false,
  [Flag.ADMIN_DEMO_POLICY_AGENTS_ENABLED]: false,
  [Flag.BYO_DB_DEMO]: { enabled: false },
  [Flag.CODE_SECURITY_DEPENDENCY_SCAN_ENABLED]: false,
  [Flag.CODE_SECURITY_SBOM_ENABLED]: false,
  [Flag.POLICY_GATES_MVP_ENABLED]: false,
  [Flag.POLICY_GATES_SECURITY_SCANS_ENABLED]: false,
  [Flag.POLICY_GATES_DEPENDENCY_SCAN_ENABLED]: false,
  [Flag.UI_V2_REVERT_OVERRIDE_ENABLED]: false,
  [Flag.SECRETS_MANAGEMENT_V2_ENABLED]: false,
} satisfies AllFlags;
